import React, {
  useContext,
} from 'react'
import { BestSellerDisplay as CPBestSeller, Title } from '@usap/widgets'
import { Box } from '@usap/uicomponents'
import { LocalContext } from '../../../helpers/useLocalContext'
import staticStyle from './SeoBestSeller.css'
import useReviews from '../../../../hooks/useReviews'

const BestSellerView = ({ Link, review }) => {
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext
  const { reviewCount } = useReviews(review.productId)
  return (
    <CPBestSeller item={review} reviewCount={reviewCount} Link={Link} isBot={isBot} />
  )
}

export default function SeoBestSeller({ dynamicApiData }) {
  const {
    headings,
    reviews,
  } = dynamicApiData
  const title = headings?.reviews || 'Top Rated Products'
  const { localContext } = useContext(LocalContext)
  const { Link } = localContext

  if (reviews.length === 0 || !reviews) {
    return null
  }

  return (
    <Box
      id="BestSeller"
      width="1248px"
      margin={staticStyle.box1Marg}
      pad={staticStyle.box1Pad}
    >
      <Box margin={staticStyle.boxMargin}>
        <Title type="h2" size="20px" label={title} />
      </Box>
      <Box style={staticStyle.reviewBoxContainer}>
        {
          reviews.length > 0 && reviews.map(
            review => <BestSellerView Link={Link} review={review} key={review.productId} />,
          )
          }
      </Box>
    </Box>
  )
}
